/**
* Scrolling Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 768 ) {
        const headerHeight = $( 'header.navbar' ).height();
        const top = headerHeight + 24;

        const overlappingCards = gsap.utils.toArray( '.scrolling-cards__card' );
        let totalCardsHeight = 0;
        let lastCardHeight = 0;
        $( '.scrolling-cards__card' ).each( function( i ) {
          totalCardsHeight += $( this ).height();
          if ( i == overlappingCards.length - 1 ) {
            lastCardHeight = $( this ).height();
          }
        } );

        const spacer = 80;

        overlappingCards.forEach( ( card, index ) => {
          ScrollTrigger.create( {
            trigger: card,
            start: `top top+=${top + ( index * spacer )}px`,
            pin: true,
            pinSpacing: false,
            id: `pin-${index}`,
            end: `bottom top+=${ totalCardsHeight - lastCardHeight + top - 20 }`,
            endTrigger: '.scrolling-cards',
            invalidateOnRefresh: true,
            // markers: true,
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-cards', COMPONENT );
} )( app );
